import { useState, useEffect } from "react";
import app from "nystem";
import { Button, Icon } from "nystem-components";

const ViewButtonClone = ({ view, model, value, setValue }) => {
  const [active, setActive] = useState(false);

  const doCopyVal = () => {
    setActive(true);

    app().cloneTempValue = app().clone({
      ...value,
      _id: undefined,
      _crdate: undefined,
    });

    const { pathname } = window.location;
    window.window.history.pushState(
      {},
      "",
      pathname.replace(`/${view.value._id}`, "")
    );

    setTimeout(() => {
      setActive(false);
    }, 200);
  };

  useEffect(() => {
    const value = app().cloneTempValue;
    if (!value) return;
    setTimeout(() => {
      setValue(value);
    }, 200);
    delete app().cloneTempValue;
  }, [setValue]);

  return (
    <Button
      renderAs="button"
      className={[...(model.className || []), active ? "copyItemBounce" : ""]}
      type={model.btnType}
      onClick={doCopyVal}
      size={model.btnSize}
      title={model.direction}
    >
      <Icon className="h-4 w-4 mr-2" icon="clone" alt={model.text} />
      {app().t(model.text)}
    </Button>
  );
};

export default ViewButtonClone;
